import darkTheme from './darkBaseTheme.js';
import lightTheme from './lightBaseTheme.js';
import legacyTheme from './legacyTheme.js';

const darkBaseThemeWithLegacy = {
    ...darkTheme,
    ...legacyTheme
};
const lightBaseThemeWithLegacy = {
    ...lightTheme,
    ...legacyTheme
};

export { darkBaseThemeWithLegacy as darkBaseTheme, lightBaseThemeWithLegacy as defaultTheme, lightBaseThemeWithLegacy as lightBaseTheme };
